export const FEATURE_FLAG_TYPES = [
  { label: 'Boolean', value: 'boolean' },
  { label: 'String', value: 'string' }
];

export const DEFAULT_FILTERS = {
  key: {
    title: 'Feature Flag',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  type: {
    values: null,
    title: 'Type',
    placeholder: 'Search by type',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: FEATURE_FLAG_TYPES.filter((type) =>
          type.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'feature_flag_types.options',
    icon: 'list-unordered-mono'
  }
};

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: false
};
